import * as React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { Button } from './radix-button';
import { cn } from '@commenda/utils';
import { Calendar } from './calendar';
import { NonTimezoneSensitiveDate } from '@commenda/utils';

export function DatePicker({
  date,
  setDate,
  disableFutureDate,
}: {
  date: Date;
  setDate: React.Dispatch<React.SetStateAction<Date>>;
  disableFutureDate?: boolean;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'w-full justify-start text-left font-normal',
            !date && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? NonTimezoneSensitiveDate.fromNativeDate(date).format('MMM DD, YYYY') : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
          disableFutureDays={disableFutureDate}
        />
      </PopoverContent>
    </Popover>
  );
}
